<div class="row mb-2">
  <div class="col-md-2">
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="_id">Id</option>
      <option value="firstName">Name</option>
      <option value="phoneNumber">Mobile Number</option>
      <option value="city">City</option>
      <option value="vehicleType">Vehicle Type</option>
      <option value="homeStopLocation">Home Stop</option>
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      (click)="search()"
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div>

  <!-- <div class="col-md-6">
    <div>
      <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control  "
        placeholder="Search by driver name " style="width: 70%">
    </div>

  </div> -->

  <div class="col-md-6 m-0 text-end">
    <button
      (click)="exportToExcel()"
      style="margin-right: 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <button class="btn-shadow d-inline-flex align-items-center btn btn-success">
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
    </button>
  </div>
</div>

<div>
  <div class="card-header font-weight-B fs-1r">
    All Drivers
    <!-- <div> Total Active Drivers <input class="col-md-1" type="number" [ngModel]="totalItems" disabled></div> -->
  </div>

  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <button
        class="nav-link active"
        id="nav-home-tab"
        data-bs-toggle="tab"
        data-bs-target="#userActive"
        type="button"
        role="tab"
        aria-controls="userActive"
        aria-selected="true"
      >
        <i class="fa fa-clock-o" aria-hidden="true" (click)="getDrivers()"></i>
        Active Drivers
        <input
          class="text-center text-primary border border-primary rounded"
          *ngIf="totalItems"
          style="width: 30px"
          disabled
          [ngModel]="totalItems"
        />
      </button>
      <button
        class="nav-link"
        id="nav-profile-tab"
        data-bs-toggle="tab"
        data-bs-target="#userDeleted"
        type="button"
        role="tab"
        aria-controls="userDeleted"
        aria-selected="false"
      >
        <i
          class="fa fa-trash"
          aria-hidden="true"
    
        ></i>
        Deleted Drivers
        <input
          class="text-center text-primary border border-primary rounded"
          *ngIf="totalDeletedItems"
          style="width: 30px"
          disabled
          [ngModel]="totalDeletedItems"
        />
      </button>
    </div>
    <!-- <div> Total Active Drivers <input class="col-md-1" type="number" [ngModel]="totalItems" disabled></div> -->
  </nav>

  <div class="tab-content" id="nav-tabContent">
    <div
      class="tab-pane fade show active"
      id="userActive"
      role="tabpanel"
      aria-labelledby="pending-tab"
    >
      <div class="table-responsive">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
          id="excel-table"
        >
          <thead>
            <tr>
              <th class="w-15">Id</th>
              <th>Name</th>
              <th>Mobile No.</th>
              <th>Email Id</th>
              <th>Home Stop</th>
              <th>City</th>
              <th>Vehicle Type</th>
              <th>Created On</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let data of allDriversList | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page_active,
                    totalItems: totalItems
                  } 
                
              "
            >
            <!-- | paginate
            : {
                itemsPerPage: itemsPerPage,
                currentPage: page,
                totalItems: totalItems
              } -->
              <td class="w-15">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data._id }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="w-15">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{ data.firstName }} {{ data.lastName }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.phoneNumber }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{ data.emailId }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{ data.homeStopLocation }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.city }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.vehicleType }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{
                          data.createdOnTS * 1000
                            | date : "dd MMM yyyy hh:mm a" : "en-IN"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-info dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Action
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="routeWalletDetails(data)"
                        >Wallet <i class="fa fa-eye"></i
                      ></a>
                    </li>                  
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="viewDetails1(content2, data)"
                        >View Driver Details <i class="fa fa-eye"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="editDriver(content1, data)"
                        >Edit <i class="fa fa-pencil"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="viewReviews(data)"
                        >Reviews <i class="fa fa-pencil"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
          <div
            *ngIf="allDriversList?.length == 0"
            class="text-center mt-5 mb-5"
          >
            <span class="text-danger">Data Not found</span>
          </div>
        </table>
        <!-- <pagination-controls
          class="my-pagination"
          (pageChange)="gty((page = $event))"
        ></pagination-controls> -->

        
        <!-- <div class="pagination">
          <button (click)="gty(currentACPage - 1)" [disabled]="currentACPage <= 0">Previous</button>
          <span>Page {{ currentACPage + 1 }} of {{ totalAcDPages }}</span>
          <button (click)="gty(currentACPage + 1)" [disabled]="currentACPage >= totalAcDPages - 1">Next</button>
        </div> -->
    
        <!-- <div class="pagination">
          <button (click)="gty(currentACPage - 1)" [disabled]="currentACPage <= 0">Previous</button>
          <button (click)="gty(currentACPage-1)">{{currentACPage -1}}</button>
          <button (click)="gty(currentACPage)">{{currentACPage}}</button>
          <button (click)="gty(currentACPage+2)">{{currentACPage + 2}}</button>
          
          <button (click)="gty(totalAcDPages)" >{{totalAcDPages}}</button>
          <button (click)="gty(currentACPage + 1)" [disabled]="currentACPage >= totalAcDPages - 1">Next</button>
      </div> -->


      <!-- <ngb-pagination (click)="gty(page)" [collectionSize]="totalItems" [(page)]="page" [maxSize]="itemsPerPage" [rotate]="true"
      [boundaryLinks]="true"></ngb-pagination> -->
        
      <ngb-pagination 
      (pageChange)="gty(page_active = $event)" 
      [collectionSize]="totalItems" 
      [(page)]="page_active" 
      [pageSize]="itemsPerPage" 
      [maxSize]="3" 
      [rotate]="true" 
      [boundaryLinks]="false">
      </ngb-pagination> 
        
        
      </div>
    </div>

    <div
      class="tab-pane fade"
      id="userDeleted"
      role="tabpanel"
      aria-labelledby="userDeleted"
    >
      <div class="table-responsive">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
          id="excel-table"
        >
          <thead>
            <tr>
              <th class="w-15">ID</th>
              <th>Name</th>
              <th>Mobile No</th>
              <th>Email Id</th>
              <th>City</th>
              <th>Created On</th>

              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let data of allDeletedDriversList
               
              "
            >
            <!-- | paginate
            : {
                itemsPerPage: itemsPerPage,
                currentPage: page,
                totalItems: totalDeletedItems
              } -->
              <td class="w-15">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data._id }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{ data.firstName }} {{ data.lastName }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.phoneNumber }}</div>
                    </div>
                  </div>
                </div>
              </td>
               <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.emailId }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.city }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{
                          data.createdOnTS * 1000
                            | date : "dd MMM yyyy hh:mm a" : "en-IN"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-info dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Action
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="viewDetails1(content2, data)"
                        >View Details <i class="fa fa-eye"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="editDriver(content1, data)"
                        >Edit <i class="fa fa-pencil"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
          <div
            *ngIf="allDeletedDriversList?.length == 0"
            class="text-center mt-5 mb-5"
          >
            <span class="text-danger">Data Not found</span>
          </div>
        </table>
        <!-- <pagination-controls
          class="my-pagination"
          (pageChange)="gty_Del((page = $event))"
        ></pagination-controls> -->

        <!-- <div class="pagination">
          <button (click)="gty_Del(currentDelDPage - 1)" [disabled]="currentDelDPage <= 0">Previous</button>
          <span>Page {{ currentDelDPage + 1 }} of {{ totalDelDPages }}</span>
          <button (click)="gty_Del(currentDelDPage + 1)" [disabled]="currentDelDPage >= totalDelDPages - 1">Next</button>
        </div> -->

        <ngb-pagination 
        (pageChange)="gty_Del(page_Deleted = $event)" 
        [collectionSize]="totalDeletedItems" 
        [(page)]="page_Deleted" 
        [pageSize]="itemsPerPage" 
        [maxSize]="3" 
        [rotate]="true" 
        [boundaryLinks]="false">
        </ngb-pagination> 
      </div>
    </div>
  </div>
</div>

<!-- Edit Model -->
<div class="card-body modal-lg">
  <ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title"><i class="fa fa-eye"></i> Update Information</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">ID : </label>
            <input
              type="text"
              [ngModel]="_id"
              [disabled]="true"
              [disabled]="true"
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">User ID : </label>
            <input
              type="text"
              [ngModel]="userId"
              [disabled]="true"
              [disabled]="true"
              class="form-control"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Name : </label>
            <input
              type="text"
              [ngModel]="firstName + ' ' + lastName"
              disabled
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">Status : </label>

            <select
              name=""
              id=""
              [ngModel]="status"
              disabled
              class="form-control"
            >
              <option value="0">0</option>
              <option value="offline">Offline</option>
              <Option value="online">Online</Option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Email : </label>
            <input
              type="text"
              [(ngModel)]="emailId"
           
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">Mobile : </label>
            <input
              type="text"
              [(ngModel)]="phoneNumber"
              class="form-control"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">City : </label>
            <input type="text" [(ngModel)]="city" class="form-control" />
          </div>
          <div class="col-md-5">
            <label for="">State : </label>
            <input type="text" [(ngModel)]="state" class="form-control" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <!-- <div class="col-md-5">
        <label for="">Pin Code : </label>
        <input type="text"    [ngModel]="pincode"   class="form-control">
      </div> -->
          <div class="col-md-5">
            <label for="">Home Stop : </label>
            <input
              type="text"
              [(ngModel)]="homeStopLocation"
              (onAddressChange)="getHomeStopData($event)"
              ngx-google-places-autocomplete
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">IsPhoneVerified : </label>
            <select
              name=""
              id=""
              [(ngModel)]="isPhoneVerified"
              class="form-control"
            >
              <option value="">Select Phone Verification</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">RefBy : </label>
            <input type="text" [(ngModel)]="refBy" class="form-control" />
          </div>
          <div class="col-md-5">
            <label for="">RefCode : </label>
            <input type="text" [(ngModel)]="refCode" class="form-control" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">KYC : </label>

            <select name="" id="" [(ngModel)]="kyc" class="form-control">
              <option value="">Select Kyc Status</option>
              <option value="1">Approved</option>
              <option value="0">Pending</option>
              <option value="2">Reject</option>
            </select>
          </div>
          <div class="col-md-5">
            <label for="">RefCode : </label>
            <input type="text" [(ngModel)]="rating" class="form-control" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Vehicle ID : </label>
            <input type="text" [(ngModel)]="vehicaleId" class="form-control" />
          </div>
          <div class="col-md-5">
            <label for="">Vehicle Name : </label>
            <input type="text" [(ngModel)]="vehicleName" class="form-control" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Vehicle Number : </label>
            <input
              type="text"
              [(ngModel)]="vehicleNumber"
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">Vehicle Type : </label>
            <select class="form-control" [(ngModel)]="vehicleType">
              <option value="">Select Vehicle Type</option>
              <option
                value="{{ data.type }}"
                *ngFor="let data of allVehiclesList"
              >
                {{ data.type }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Banner Pasted : </label>
            <select name="" id="" class="form-control"[(ngModel)]="isBannerPasted">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
          <div class="col-md-5">
            <label for="">Verification Status : </label>
            <select
              name=""
              id=""
              class="form-control"
              [(ngModel)]="verificationStatus"
            >
              <option value="">Verification Status</option>
              <option value="0">Pending</option>
              <option value="1">Inprogress</option>
              <option value="2">Approved</option>
              <option value="3">Rejected</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Current balance : </label>
            <input
              type="text"
              [ngModel]="currentBalance"
              [disabled]="true"
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">Created On : </label>
            <input
              type="text"
              [ngModel]="
                createdOnTS * 1000 | date : 'dd MMM yyyy hh:mm a' : 'en-IN'
              "
              [disabled]="true"
              class="form-control"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Update Driver Active Status :</label>
            <select name="" id="" [(ngModel)]="isDeleted" class="form-control">
              <option value="">Update Driver Active Status</option>
              <option [ngValue]="0">Active</option>
              <option [ngValue]="1">Inactive</option>
            </select>
          </div>
          <div class="col-md-2"></div>
        </div>
        <hr class="mt-2" />
        <div class="row">
          <div class="col-md-1"></div>
          <h6 class="col-md-4">Bank Details</h6>
        </div>

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Name As Per Bank : </label>
            <input
              type="text"
              [(ngModel)]="nameAsPerBank"
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">Account Number : </label>
            <input
              type="text"
              [(ngModel)]="bankAccountNumber"
              class="form-control"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">IFSC Code : </label>
            <input type="text" [(ngModel)]="ifscCode" class="form-control" />
          </div>
          <div class="col-md-5">
            <label for="">Bank Name : </label>
            <input type="text" [(ngModel)]="bankName" class="form-control" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Upi Mobile No : </label>
            <input
              type="text"
              [(ngModel)]="upiMobileNumber"
              class="form-control"
            />
          </div>
          <div class="col-md-5">
            <label for="">Upi ID: </label>
            <input type="text" [(ngModel)]="upiID" class="form-control" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <label for="">Payment App : </label>
            <input type="text" [(ngModel)]="paymentApp" class="form-control" />
          </div>
        </div>

        <div class="row mt-2 mb-2 text-center">
          <div class="col-md-12">
            <button
              (click)="updateDriver()"
              class="btn btn-primary btn-lg btn-block"
            >
              Update Driver
            </button>
          </div>
        </div>

        <div class="col-md-1"></div>
      </div>
    </div>
  </ng-template>
</div>

<!-- View Details/Documents Model -->
<div class="card-body modal-lg">
  <ng-template #content2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title"><i class="fa fa-eye"></i> View Details</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            class="nav-link active"
            id="nav-details-tab"
            data-bs-toggle="tab"
            data-bs-target="#viewDetails"
            type="button"
            role="tab"
            aria-controls="viewDetails"
            aria-selected="true"
          >
            <i class="fa fa-info" aria-hidden="true"></i> Driver Details
          </button>
          <button
            class="nav-link"
            id="nav-docs-tab"
            data-bs-toggle="tab"
            data-bs-target="#documents"
            type="button"
            role="tab"
            aria-controls="Documents"
            aria-selected="false"
            (click)="getDriverDocuments()"
          >
            <i class="fa fa-file-text" aria-hidden="true"></i> Documents
          </button>
        </div>
      </nav>

      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane fade show active"
          id="viewDetails"
          role="tabpanel"
          aria-labelledby="viewDetails-tab"
        >
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-3">
              <label for="">Name : </label>
              <input
                type="text"
                [ngModel]="
                  viewAllData1?.firstName + ' ' + viewAllData1?.lastName
                "
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-3">
              <label for="">Mobile : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.phoneNumber"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-4">
              <label for="">Vehicle Type : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.vehicleType"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">City : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.city"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-7 mt-2">
              <label for="">Home Stop : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.homeStopLocation"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Vehicle Number : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.vehicleNumber"
                [disabled]="true"
                class="form-control"
              />
            </div>

            <div class="col-md-3 mt-2">
              <label for="">Email : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.emailId"
                [disabled]="true"
                class="form-control"
              />
            </div>

            <div class="col-md-4 mt-2">
              <label for="">ID : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?._id"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>

            <div class="col-md-3 mt-2">
              <label for="">Status : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.status"
                [disabled]="true"
                class="form-control"
              />
            </div>

            <div class="col-md-3 mt-2">
              <label for="">Verification Status : </label>
              <input
                type="text"
                [ngModel]="
                  viewAllData1?.verificationStatus == 0
                    ? 'Pending'
                    : viewAllData1?.verificationStatus == 1
                    ? 'In-Process'
                    : viewAllData1?.verificationStatus == 2
                    ? 'Completed'
                    : viewAllData1?.verificationStatus == 3
                    ? 'Rejected'
                    : ''
                "
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">Controlled By Admin : </label>
              <input
                type="text"
                [ngModel]="
                  viewAllData1?.isControlledByAdmin == true ? 'Yes' : 'No'
                "
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2 mb-2">
              <label for="">Current balance : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.currentBalance"
                [disabled]="true"
                class="form-control"
              />
            </div>

            <div class="col-md-3 mt-2">
              <label for="">Registration Date : </label>
              <input
                type="text"
                [ngModel]="
                  viewAllData1?.createdOnTS * 1000
                    | date : 'dd MMM yyyy hh:mm a' : 'en-IN'
                "
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">Approved On : </label>
              <input
                type="text"
                [ngModel]="
                  viewAllData1?.updatedOnTS * 1000
                    | date : 'dd MMM yyyy hh:mm a' : 'en-IN'
                "
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Banner Pasted : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.isBannerPasted == true ? 'Yes' : 'No'"
                [disabled]="true"
                class="form-control"
              />
            </div>

            <div class="col-md-1"></div>
            <hr class="m-0" />
            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Name As Per Bank : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.nameAsPerBank"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">Bank Name : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.bankName"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">UPI Mobile No : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.upiMobileNumber"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">UPI ID: </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.upiID"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">IFSC Code : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.ifscCode"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">Account Number : </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.bankAccountNumber"
                [disabled]="true"
                class="form-control"
              />
            </div>

            <div class="col-md-1"></div>
            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Digital Wallet: </label>
              <input
                type="text"
                [ngModel]="viewAllData1?.paymentApp"
                [disabled]="true"
                class="form-control"
              />
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>

        <div
          class="tab-pane fade show"
          id="documents"
          role="tabpanel"
          aria-labelledby="documents-tab"
        >
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="row">
                <div
                  class="col-md-6 mt-4 mb-4"
                  *ngFor="let data of driverDocumentsData"
                >
                  <label for="" class="mt-2 mb-2 font-size-xlg font-weight-B">{{
                    data.documentType
                  }}</label>
                  <img
                    src="{{ data.file }}"
                    alt=""
                    width="100%"
                    height="auto"
                  />
                </div>
                <div
                  *ngIf="driverDocumentsData.length == 0"
                  class="text-center text-danger mt-4 mb-4"
                >
                  <span>Data Not found </span>
                </div>
                <!-- <div class="col-md-6">5</div> -->
                <!-- <div class="col-md-6">5</div> -->
                <!-- <div class="col-md-6">5</div> -->
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
